import React, { memo } from 'react';
import { AppTooltip } from './tooltip';

interface SidebarButtonProps {
  icon: React.ReactNode;
  isActive?: boolean;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  tooltipMessage?: string;
  disabled?: boolean;
}

const SidebarButton: React.FC<SidebarButtonProps> = memo(({ icon, isActive, onClick, tooltipMessage, disabled }) => {
  return (
    <AppTooltip content={tooltipMessage} disabled={disabled}>
      {/* A BUTTON, AND ONE WITH A NAME. This was a bare div carrying only a hover tooltip, so the
          three primary navigation controls of the module - previous subject, next subject, back to
          dashboard - were invisible to a screen reader, unreachable by keyboard, and impossible to
          address by role in a test. The last of those is why the journey harness could only click
          them by index, which is how a proof ends up clicking whatever happens to be third on the
          screen. The tooltip already holds the human name; it is now the accessible name too. */}
      <div
        role="button"
        tabIndex={disabled ? -1 : 0}
        aria-label={tooltipMessage}
        aria-disabled={disabled || undefined}
        onClick={onClick}
        onKeyDown={(event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          onClick?.(event as unknown as React.MouseEvent<HTMLDivElement>);
        }}
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '32px',
          height: '32px',
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
        }}
      >
        <div
          className={`rounded-full transition-colors ${isActive ? 'blue--selected' : 'text-[#E5E5E5] hover:bg-white/[0.08] hover:text-white'}`}
          style={{
            position: 'relative',
            zIndex: 1,
            ...(isActive ? { color: '#000000' } : {}),
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {icon}
        </div>
      </div>
    </AppTooltip>
  );
});

SidebarButton.displayName = 'SidebarButton';

export default SidebarButton;
